import Vue from 'vue'
import CONF from '@/app.conf.json'
import {Util} from '../commons/util'

// Promise 垫片
require('core-js/fn/promise');

let Service = {

    /**
     * 查询会员信息（ID、头像）
     * @params {String} custNum   会员编码
     * @return Promise
     * */
    queryUserInfo(){
        let url = CONF.API.queryUserInfo,
            jsonpCallback = 'queryUserInfoCallback';

        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                jsonpCallback: jsonpCallback
            }).then(data => {
                if(data.body.code === '0'){
                    resolve(data.body)
                }else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data => {
                reject(new Error(data))
            });
        });
    },
    /**
     * 查会员权益
     * @param cityCode
     * @returns {Promise}
     */
    vipBenefits(storeCode){
        let url = CONF.API.vip,
            jsonpCallback = 'vipCallback';
        
        url = url
            .replace('{{storeCode}}', storeCode)
            .replace('{{callback}}', jsonpCallback);
        
        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url,{
                jsonpCallback: jsonpCallback
            }).then(data => {
                if(data.body.code === '0' || data.body.code === '0005'){
                    resolve(data.body.data)
                }else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data=>{
                reject(new Error(data))
            });
        });
    },
    ticketList(cityCode, storeCode) {
        let url = CONF.API.ticketList,
            jsonpCallback = 'allbac';
    
        url = url
            .replace('{{cityCode}}', cityCode)
            .replace('{{storeCode}}', storeCode)
            .replace('{{callback}}', jsonpCallback);
    
        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url,{
                jsonpCallback: jsonpCallback
            }).then(data => {
                if(data.body.code === '0'){
                    resolve(data.body.data)
                }else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data=>{
                reject(new Error(data))
            });
        });
    }
};

export default Service;



// WEBPACK FOOTER //
// ./src/services/MyCenter.js